import ReturnedItem from "../classes/ReturnedItem";

export function ImportReturnedItemsData(sheet)
{
    let container = document.createElement('div');
    document.body.append(container);

    //const lastCol = sheet.lastColumn.number;
    const lastRow = sheet.lastRow.number;

    console.log('last row ' + sheet.lastRow, sheet.lastRow);

    const products = [];

    for(let i = 4; i < lastRow; i++)
    {
        const r = sheet.getRow(i);
        if (r.getCell(3).value === null)
        {
            // No product found, we are done
            break;
        }

        const prod = new ReturnedItem(r);
        products.push(prod);
    }

    return products;
}